import AsyncStorage from '@react-native-async-storage/async-storage';
import React, {useEffect, useState} from 'react';
import {useForm} from 'react-hook-form';
import {StyleSheet, Text, TouchableOpacity, View} from 'react-native';
import {CountryButton, CountryPicker} from 'react-native-country-codes-picker';
import {useSelector} from 'react-redux';
import {globalFontStyle, globalStyle} from '../../../assets';
import Colors from '../../../assets/Color/Colors';
import Width from '../../../assets/Width';
import {globalImport} from '../../../common/globalImports';
import ShowError from '../../../common/ShowError';
import {Button} from '../../../components/core/Button';
import {Input} from '../../../components/core/Input';
import {
  CountryRegEx,
  isMobile,
} from '../../../utils/commonMethods';
import {globalConst, globalConfigurableData} from '../../../utils/globalConstant';
import {Network} from '../../../utils/network';

const LoginViaMobile = ({
  country,
  isIndia,
  showMobileOnly,
  onPromoSuccessSet,
  onLoginSubmit,
  setCountry,
}) => {
  const [IspromoSuccess, setIsPromoSuccess] = useState(null);
  const [show, setShow] = useState(false);
  const [countryList, setCountryList] = useState([]);

  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: {errors, isValid},
    watch,
  } = useForm({mode: 'onChange'});

  const {
    register: registerPromo,
    control: controlPromo,
    formState: {errors: errors2, isValid: isValid2},
    handleSubmit: handleSubmitPromo,
    setValue,
  } = useForm({
    mode: 'onChange',
  });

  const watchNo = watch('mobileNumber');

  const globalConfigData = useSelector(
    state => state.utilReducer.globalConfigData,
  );

  const onSubmitPromoCode = (data, event) => {
    onPromoApply(data?.promoCode);
    event.preventDefault();
  };

  const onFormSubmit = source => {
    onLoginSubmit(watchNo, false, source);
  };
  const getPromo = async () => {
    const promo = await AsyncStorage.getItem('promoCode');
    if (promo && promo !== 'undefined' && promo !== undefined) {
      setValue('promoCode', promo, {shouldValidate: true});
      onPromoApply(promo);
    }
  };

  useEffect(() => {
    // if (isIndia) {
    //   getPromo();
    // }
    reset({
      mobileNumber: '',
    });
  }, []);

  useEffect(() => {
    const tempList = [];
    globalConfigData?.countries?.map(data => {
      tempList.push(data?.iso_code);
    });
    setCountryList(tempList);
  }, [globalConfigData]);

  const onPromoApply = async promo => {
    const inputObj = {
      coupon: promo,
      signup_country: country.code,
    };
    const res = await Network.verifyCouponCode(inputObj);

    // trackMoengageEvent('Added Referral Code', {
    //   Valid: res?.data?.isvalid ? true : false,
    //   Code: promo,
    // });

    if (!res?.data?.isvalid) {
      onPromoSuccessSet('');
      setIsPromoSuccess({
        val: 'Apply',
        divClass: {borderColor: Colors.red, borderWidth: 2},
        message: res?.data?.message,
        errorClass: {color: Colors.red},
      });
    } else {
      onPromoSuccessSet(promo);
      setIsPromoSuccess({
        val: 'Remove',
        divClass: {borderColor: Colors.green, borderWidth: 2},
        message: res?.data?.message,
        errorClass: {color: Colors.green},
      });
    }
  };
  return (
    <View style={{marginTop: 15}}>
      <View style={styles.inputContainer}>
        <View
          style={{
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: 6,
          }}>
          <View style={{flex: 1}}>
            <Input
              name="mobileNumber"
              placeholder="Enter mobile"
              control={control}
              variant="default"
              size="default"
              numeric={true}
              prefix={country.dial_code}
              label="Phone Number"
              prefixStyle={{
              }}
              rules={{
                required: 'Mobile number cannot be empty',
                validate: {
                  min: value => {
                    return (
                      globalConst.MMNumbers.includes(value) ||
                      value > 1000000000 ||
                      'Please enter a valid mobile number'
                    );
                  },
                },
                max: {
                  value: '9999999999',
                  message: 'Please enter a valid mobile number ',
                },
              }}
            />
          </View>
        </View>
      </View>

      <Button
        variant="primary"
        disabled={!isValid}
        onPress={handleSubmit(() => onFormSubmit('sms'))}
        style={{
          marginBottom: 20,
          marginTop: 30,
          width: !isMobile() ? '100%' : undefined,
          flex: !globalImport.isWeb ? 0 : undefined
        }}
      >
        {showMobileOnly ? 'Proceed' : 'Get OTP via SMS'}
      </Button>
    </View>
  );
};

export default LoginViaMobile;

const styles = StyleSheet.create({
  loginErrorBar: {
    ...globalFontStyle.appFontSubText,
    backgroundColor: '#ff2626',
    paddingVertical: 8,
    width: '100%',
    paddingLeft: 5,
    alignItems: 'center',
    color: Colors.bgWhite,
  },
  inputContainer: {
    marginBottom: 10,
  },
  buttonStyle: {
    paddingVertical: 12,
    alignItems: 'center',
    borderRadius: 5,
    flexDirection: 'row',
    borderColor: Colors.black,
    borderWidth: 1,
    justifyContent: 'center',
  },
});
